import React, { lazy } from 'react';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { AudioPlayer } from './AudioPlayer';
export const HeroSection = () => {
  return <section className="py-8 md:py-10 relative overflow-hidden" data-id="element-168">
      <div className="absolute inset-0 bg-bttf-highlight/10 mix-blend-overlay" data-id="element-169"></div>
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center relative z-10 gap-6 md:gap-8" data-id="element-170">
        <div className="md:w-1/2 mb-4 md:mb-0 md:pr-8 flex flex-col w-full md:justify-between md:min-h-[600px]" data-id="element-171">
          <div className="order-1" data-id="element-172">
            <div className="flex items-center gap-1.5 md:gap-4 mb-3 md:mb-6 flex-nowrap" data-id="element-173">
              <div className="inline-block bg-bttf-primary text-bttf-text font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-md shadow-[0_0_15px_#FF6C00,0_0_25px_#FFD300] animate-pulse whitespace-nowrap text-sm md:text-base" data-id="element-174">
                🏆 BEST SELLER
              </div>
              <div className="flex items-center gap-0.5 md:gap-2 flex-shrink-0 flex-nowrap" data-id="element-175">
                <div className="flex items-center gap-0.5" data-id="element-176">
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-[#FFD300] fill-[#FFD300]" data-id="element-177" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-[#FFD300] fill-[#FFD300]" data-id="element-178" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-[#FFD300] fill-[#FFD300]" data-id="element-179" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-[#FFD300] fill-[#FFD300]" data-id="element-180" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-[#FFD300] fill-[#FFD300]" data-id="element-181" />
                </div>
                <span className="text-base md:text-xl font-bold text-bttf-text" data-id="element-182">
                  5.0
                </span>
                <span className="text-xs md:text-lg text-bttf-subtext whitespace-nowrap" data-id="element-183">
                  (5,354+ Reviews)
                </span>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-8 font-future tracking-tight bg-gradient-main text-transparent bg-clip-text leading-tight" data-id="element-184">
              Back In Time: 40th Anniversary Collector's Edition
            </h1>
          </div>

          <div className="order-2 md:hidden flex justify-center mb-6" data-id="element-185">
            <div className="relative" data-id="element-186">
              <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-md opacity-75" data-id="element-187"></div>
              <div className="relative bg-bttf-bg rounded-lg overflow-hidden shadow-2xl transform rotate-0 hover:rotate-3 transition-transform duration-300 border border-bttf-accent/30" data-id="element-188">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sknkyYheWwTcy5e6Yw5kQo/Generated_Image_October_24%2C_2025_-_10_36AM.png" alt="Back In Time: 40th Anniversary Collector's Edition Book Cover" className="w-full h-auto object-cover" loading="lazy" data-id="element-189" />
              </div>
            </div>
          </div>

          <p className="text-xl mb-6 md:mb-10 text-bttf-subtext leading-relaxed order-3 md:order-2" data-id="element-190">
            The timeless story that redefined imagination and friendship.
            <br className="hidden md:block" data-id="element-191" />
            <span className="block mt-2" data-id="element-192">
              Celebrating 40 years of the film that made us believe in time
              again.
            </span>
          </p>

          <div className="order-4 md:order-3 bg-gradient-to-br from-bttf-bg via-bttf-bg to-bttf-primary/10 border-2 border-bttf-accent/40 px-6 py-5 rounded-xl shadow-[0_0_20px_rgba(0,195,255,0.3)] backdrop-blur-sm hover:shadow-[0_0_30px_rgba(0,195,255,0.5)] transition-all duration-300 mb-6 md:mb-10" data-id="element-193">
            <div className="flex items-center gap-3 mb-4" data-id="element-194">
              <span className="text-2xl" data-id="element-195">🎧</span>
              <span className="text-lg font-bold text-bttf-accent font-future tracking-wide" data-id="element-196">
                Preview the Book Here
              </span>
            </div>
            <AudioPlayer src="https://cdn.shopify.com/s/files/1/0586/4069/5378/files/BIT_Audiobook_Preview.mp3?v=1762440014" data-id="element-197" />
          </div>

          <a href="#pricing" className="order-5 md:order-4 inline-flex items-center bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text font-bold px-8 py-4 rounded-md text-lg transition-all transform hover:scale-105 shadow-md hover:shadow-neon-orange w-fit" data-id="element-198">
            Get My Copy Now
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-199" />
          </a>
        </div>

        <div className="hidden md:flex md:w-1/2 justify-center md:justify-end" data-id="element-200">
          <div className="relative" data-id="element-201">
            <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-md opacity-75" data-id="element-202"></div>
            <div className="relative bg-bttf-bg rounded-lg overflow-hidden shadow-2xl transform rotate-0 hover:rotate-3 transition-transform duration-300 border border-bttf-accent/30" data-id="element-203">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sknkyYheWwTcy5e6Yw5kQo/Generated_Image_October_24%2C_2025_-_10_36AM.png" alt="Back In Time: 40th Anniversary Collector's Edition Book Cover" className="w-full h-auto object-cover" loading="lazy" data-id="element-204" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};